import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_LCM_PETITION_PUBLISHED_ONBOARDING_SERIES_CONFIG = defineFcm(
	'lcm_petition_published_onboarding_series_config',
)
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				constraints: { type: 'array', shape: { type: 'string' } },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-site-platform-comms',
		scope: 'comms-stack',
		supportedGroups: { locales: true },
		context: 'comms stack',
		description:
			'Per-locale list of country codes for which the petition published onboarding LCM email series is enabled.',
		import: false,
		template: {
			constraints: ['AR', 'AU', 'BR', 'CA', 'DE', 'ES', 'FR', 'GB', 'ID', 'IN', 'IT', 'JP', 'MX', 'TH', 'TR', 'US'],
		},
	});
